module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_5032_burgundy.882d3451.jpg";